<template>
  <div class="article-create-form-field">
    <div class="article-create-form-field__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleFormField',
};
</script>

<style lang="scss" scoped>
.article-create-form-field  {
  display: flex;
  align-items: center;

  &__title {
    &::v-deep {
      input {
        font-weight: 600;
        font-size: 30px;
        line-height: 36px;
        @media (max-width: 992px) {
          font-size: 16px;
          line-height: 15px;
        }
      }
    }
  }

  &__content {
    width: 100%;
  }

  &__text {
    align-items: flex-start;
  }
}
</style>
